import { ExpandableLayout } from '@modules/VanOord.CMS/Frontend/cmsPage/blocks/block/expandableBlock/expandableBlock.layout'
import {
  dummyData,
  randomWysiwygList,
  randomWysiwygText
} from '@modules/VanOord.Styleguide/Frontend/config/dummyData'
import { ObjectsButtons } from '@modules/VanOord.Styleguide/Frontend/content/objects/buttons.sg'
import { ObjectsLayoutGrid } from '@modules/VanOord.Styleguide/Frontend/content/objects/layoutGrid.sg'
import { ObjectsLinks } from '@modules/VanOord.Styleguide/Frontend/content/objects/links.sg'
import { ObjectsLists } from '@modules/VanOord.Styleguide/Frontend/content/objects/lists.sg'
import { ObjectsTypography } from '@modules/VanOord.Styleguide/Frontend/content/objects/typo.sg'
import * as React from 'react'
import { Widget, any, fromJSX } from 'widgets-for-react'
import { pagination } from '../fake_data/objects'
import { styleguideChapter, styleguideExample, styleguidePart, styleguideSection } from '../helpers.mod'

export const styleguideObjects: Widget<never> = fromJSX((setState) =>
    styleguideChapter({
      type: 'objects',
      slug: 'objects',
      title: 'Design Objects',
      intro:
        'If design tokens are the atoms of the design system, design objects are the material — specifically, they what comes after. We use them to make the developer’s job easier and to give the designers some extra insight in their work.'
    })(
      any([
        styleguideSection({ type: 'objects', slug: 'objects-typography', title: 'Typography', intro: '' })(
          fromJSX(() => <ObjectsTypography />)
        ),
        styleguideSection({ type: 'objects', slug: 'objects-links', title: 'Links', intro: '' })(
          fromJSX(() => <ObjectsLinks />)
        ),
        styleguideSection({ type: 'objects', slug: 'objects-buttons', title: 'Buttons', intro: '' })(
          fromJSX(() => <ObjectsButtons />)
        ),
        styleguideSection({ type: 'objects', slug: 'objects-lists', title: 'Lists', intro: '' })(
          fromJSX(() => <ObjectsLists />)
        ),
        styleguideSection({ type: 'objects', slug: 'objects-expand', title: 'Expander', intro: '' })(
          styleguidePart({ title: '', intro: '' })(
            styleguideExample({ showExampleLabel: false, isFullScreen: false })(
              fromJSX(() => (
                  <div className="block--expand">
                    <ExpandableLayout
                      id="expandable-block-1"
                      item={{
                        title: dummyData.title,
                        description: dummyData.sentence,
                        body: randomWysiwygList(),
                        nestedBlocks: []
                      }}
                      isPrintMode={false}
                    >
                      <></>
                    </ExpandableLayout>
                    <ExpandableLayout
                      id="expandable-block-2"
                      item={{
                        title: dummyData.title,
                        body: randomWysiwygText(),
                        nestedBlocks: []
                      }}
                      isPrintMode={false}
                    >
                      <></>
                    </ExpandableLayout>
                  </div>
                )
              )
            )
          )
        ),
        styleguideSection({ type: 'objects', slug: 'objects-pagination', title: 'Pagination', intro: '' })(
          styleguidePart({ title: '', intro: '' })(
            styleguideExample({ showExampleLabel: false, isFullScreen: false })(fromJSX(() => pagination()))
          )
        ),
        styleguideSection({ type: 'objects', slug: 'objects-layout-grid', title: 'Layout Grid', intro: '' })(
          fromJSX(() => <ObjectsLayoutGrid />)
        )
      ])
    ).run(setState)
)
